<template>
  <div class="contaier">
    <div class="box md:flex md:justify-between">
      <p>Inquiry：2760 9933</p>
      <p>Copyright© 2025 Kia Hong Kong. All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterPage",
};
</script>
<style lang="scss" scoped>
.contaier {
  padding: 30px 20px;
  // background-color: #000;
  .box {
    max-width: 1000px;
    // max-width: 1240px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 30px;
    // color: #fff;
  }
}
</style>
